import React, { useState, useEffect, useContext } from "react";
import {
  Route,
  withRouter,
  Switch,
  BrowserRouter,
  Redirect,
} from "react-router-dom";

import { AccountContext } from "./Accounts";
import { isAdmin } from "../api/base";
import Login from "./Login";
import Layout from "./Layout";
import CustomLoader from "./CustomLoader";
import NotFoundPage from "./shared/NotFoundPage";
import Dashboard from "../Views/DashboardView/index";
import NewCase from "../Views/NewCaseView/NewCase";
import CaseList from "../Views/Cases/CaseList";
import Client from "../Views/ClientView";
import FieldResource from "../Views/FieldResourceView";

import Case from "../Views/CaseView/Case";

export default function MainRoutes() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { getSession } = useContext(AccountContext);

  useEffect(() => {
    getSession().then(
      () => {
        setLoggedIn(true);
        setIsLoading(false);
      },
      (err) => {
        setIsLoading(false);
      }
    );
  }, [getSession]);

  return (
    <div>
      {isLoading ? (
        <CustomLoader />
      ) : (
        <BrowserRouter>
          <Switch>
            <Route exact path="/" render={() => <Redirect to="/app" />} />
            <PublicRoute
              path="/login"
              component={Login}
              isAuthenticated={!!loggedIn}
            />
            <PrivateRoute
              path="/app"
              component={MainApp}
              isAuthenticated={!!loggedIn}
            />
            <Route component={NotFoundPage} />
          </Switch>
        </BrowserRouter>
      )}
    </div>
  );
}

const PrivateRoute = ({ component, isAuthenticated, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          React.createElement(component, props)
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: {
                from: props.location,
              },
            }}
          />
        )
      }
    />
  );
};

const PublicRoute = ({ component, isAuthenticated, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Redirect
            to={{
              pathname: "/app",
            }}
          />
        ) : (
          React.createElement(component, props)
        )
      }
    />
  );
};

const MainApp = withRouter(({ match }) => {
  return (
    <Layout>
      <Switch>
        <Route path={`${match.url}/`} exact>
          <Redirect to={`${match.url}/cases`} />
        </Route>
        <Route
          path={`${match.url}/cases/:id/:type/:caseType?/:subIndex?`}
          component={Case}
        />
        <Route path={`${match.url}/cases`} component={CaseList} />

        <Route path={`${match.url}/newCase`} component={NewCase} />

        <Route path={`${match.url}/dashboard`} component={Dashboard} />
        {isAdmin() ? (
          <>
            <Route path={`${match.url}/addClient`} component={Client} />
            <Route
              path={`${match.url}/field-resource/:action?/:id?`}
              component={FieldResource}
            />
          </>
        ) : null}

        <Route component={NotFoundPage} />
      </Switch>
    </Layout>
  );
});
